module.exports = __webpack_public_path__ + "7ab0fa8d807b0d986852841db63822f9.webp";